import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { JobQuotesState } from "@insite/client-framework/Store/Data/JobQuotes/JobQuotesState";
import { ExtendState } from "@toolkit/Framework/Types/ReduxActions";
import { Draft } from "immer";

const initialState: ExtendState<JobQuotesState> = {
    errorStatusCodeById: {},
};

const actions = {
    "Toolkit/Data/JobQuotes/FailedToLoadJobQuote": (
        draft: Draft<JobQuotesState>,
        action: { jobQuoteId: string; status: number },
    ) => {
        delete draft.isLoading[action.jobQuoteId];
        if (draft.errorStatusCodeById) {
            draft.errorStatusCodeById[action.jobQuoteId] = action.status;
        }
    },
};

const reducer = createTypedReducerWithImmer(initialState as JobQuotesState, actions);
export type JobQuotesActions = Parameters<typeof reducer>[1];
export default reducer;
